import { axiosAuthInstance } from '@config/api';
import { AvatarUpdate } from '@interfaces/avatar';

const UPDATE_AVATAR = '/users/me/update-avatar';

export const updateAvatar = (avatar: AvatarUpdate) => axiosAuthInstance.put(UPDATE_AVATAR, avatar);
